// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { GetBrandCategoriesApiParameter } from "@insite/client-framework/Services/BrandService";
import { getSelectedBrandPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getAllBrandsDataView,
    getBrandCategoriesDataView,
    getBrandStateByPath,
} from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getDealersDataView, getDealerState } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ActiveState, SeoAppProps } from "@awc/App/Widgets/SearchEngineOptimization/Type";

const getLocalBusinessActiveState = ({ state, currentPage, payload }: SeoAppProps): ActiveState => {
    const isLocationFinderPage = currentPage.type === "LocationFinderPage";
    const isDealerDetailsPage = currentPage.type === "DealerDetailsPage";

    if (isLocationFinderPage) {
        const dealers = getDealersDataView(state, state.pages.locationFinder.getDealersParameter)?.value;
        payload.dealers = dealers;
    }

    if (isDealerDetailsPage) {
        const location = getLocation(state);
        const parsedQuery = parseQueryString<{ id?: string; invite?: string }>(location.search);
        const id = parsedQuery.id;
        const dealer = getDealerState(state, id);
        if (!dealer.isLoading && dealer?.value) {
            payload.dealers = [dealer.value];
        }
    }

    return (isLocationFinderPage || isDealerDetailsPage) && !!payload.dealers?.length;
};

export default getLocalBusinessActiveState;
